import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { selectCurrentUser, selectCurrentToken } from "./auth/authSlice";
import axios from "axios";

const profileState = {
    updateState: false,
    //    loading: false,
    error: "",
    response: "",
    myProfile: [],
    myOrders: [],
    orderDetails: null,
    orderStatus: null,
    shippingAddress: [],
    notifications: [],
    success: false
};

export const fetchMyProfile = createAsyncThunk(
    "customer/myprofile",
    async (data, { getState }) => {
        const token = getState().auth.token;
        const response = await axios.get(process.env.REACT_APP_CUSTOMER_BASE_URL + `/customer/myprofile`, { headers: { Authorization: token } });
        //  console.log(response.data);
        return response.data;
    }
);
export const updateMyProfile = createAsyncThunk(
    "customer/updatemyprofile",
    async (data, { getState }) => {
        const token = getState().auth.token;
        const response = await axios.post(process.env.REACT_APP_CUSTOMER_BASE_URL + `/customer/myprofile/update`, data, { headers: { Authorization: token } });
        //  console.log(response.data);
        return response.data;
    }
);
export const mobileVerify = createAsyncThunk(
    "customer/verifymobile",
    async (data, { getState }) => {
        const token = getState().auth.token;
        const response = await axios.post(process.env.REACT_APP_CUSTOMER_BASE_URL + `/customer/mobile/verify`, data, { headers: { Authorization: token } });
        //  console.log(response.data);
        return response.data;
    }
);

export const fetchMyOrders = createAsyncThunk(
    "orders/get",
    async (data, { getState }) => {
        const token = getState().auth.token;
        const response = await axios.get(process.env.REACT_APP_ORDER_BASE_URL + `/orders/get`, { headers: { Authorization: token } });
        //  console.log(response.data);
        return response.data;
    }
);

export const fetchOrderDetails = createAsyncThunk(
    "orders/details",
    async (data, { getState }) => {
        const token = getState().auth.token;
        const response = await axios.get(process.env.REACT_APP_ORDER_BASE_URL + `/orders/details/` + data, { headers: { Authorization: token } });
        //  console.log(response.data);
        return response.data;
    }
);
export const changePassword = createAsyncThunk(
    "customer/changePassword",
    async (data, { getState, rejectWithValue }) => {
        const token = getState().auth.token;
        const response = await axios.post(
            process.env.REACT_APP_CUSTOMER_BASE_URL + `/customer/password/change`,
            data,
            { headers: { Authorization: token } }
        );
        // Check for logical error (API may return 200 even on business error)
        if (response.data.status !== "success") {
            // Use rejectWithValue with error message from API
            return rejectWithValue(response.data.message || "Unknown error");
        }
        return response.data;
    }
);
export const fetchShippingAddress = createAsyncThunk(
    "customer/fetchShippingAddress",
    async (data, { getState }) => {
        const token = getState().auth.token;
        const response = await axios.get(process.env.REACT_APP_CUSTOMER_BASE_URL + `/customer/getAddress`, { headers: { Authorization: token } });
        //  console.log(response.data);
        return response.data;
    }
);

export const deleteShippingAddress = createAsyncThunk(
    "customer/deleteShippingAddress",
    async (data, { getState }) => {
        const token = getState().auth.token;
        const response = await axios.post(process.env.REACT_APP_CUSTOMER_BASE_URL + `/customer/deleteAddress/${data}`, {}, { headers: { Authorization: token } });
        //  console.log(response.data);
        return response.data;
    }
);


export const fetchNotifications = createAsyncThunk(
    "customer/notifications",
    async (data, { getState }) => {
        const token = getState().auth.token;
        const response = await axios.post(process.env.REACT_APP_CUSTOMER_BASE_URL + `/customer/notifications`, data, { headers: { Authorization: token } });
        //  console.log(response.data);
        return response.data;
    }
);

export const deleteNotification = createAsyncThunk(
    "customer/notifications/delete",
    async (data, { getState }) => {
        const token = getState().auth.token;
        const response = await axios.post(process.env.REACT_APP_CUSTOMER_BASE_URL + `/customer/notifications/delete/${data}`, {}, { headers: { Authorization: token } });
        //  console.log(response.data);
        return response.data;
    }
);

export const deleteAccount = createAsyncThunk(
    "customer/deleteAccount",
    async (_, { getState, rejectWithValue }) => {
        const token = getState().auth.token;
        try {
            const response = await axios.post(
                process.env.REACT_APP_CUSTOMER_BASE_URL + `/customer/delete`,
                {},
                { headers: { Authorization: token } }
            );

            if (response.data.status !== "SUCCESS") {
                return rejectWithValue(response.data.message || "Failed to delete account.");
            }

            return response.data;
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || err.message || "Delete request failed.");
        }
    }
);




const ProfileSlice = createSlice({
    name: "profile",
    initialState: profileState,
    reducers: {
        clearState: (state) => {
            state.error = "";
            state.updateState = false;
            state.response = "";
            state.myProfile = [];
            state.myOrders = [];
            state.shippingAddress = [];
            state.orderDetails = null;
            state.orderStatus = null;
            state.success = false;
            state.notifications = [];
        }
    },
    extraReducers: (builder) => {

        builder
            .addCase(fetchMyProfile.fulfilled, (state, action) => {
                if (action.payload.status == "SUCCESS") {
                    state.myProfile = action.payload.data.result;
                }
            })
            .addCase(fetchMyProfile.rejected, (state, action) => {
                state.error = action.error.message;
            });
        builder
            .addCase(fetchMyOrders.fulfilled, (state, action) => {
                if (action.payload.status == "SUCCESS") {
                    // console.log(action.payload.data);
                    state.myOrders = action.payload.data;
                    state.orderStatus = action.payload.OrderStatusData;
                }
            })
            .addCase(fetchMyOrders.rejected, (state, action) => {
                state.error = action.error.message;
            });
        builder
            .addCase(fetchOrderDetails.fulfilled, (state, action) => {
                if (action.payload.status == "SUCCESS") {
                    state.orderDetails = action.payload.data;
                    state.orderStatus = action.payload.OrderStatusData;
                }
            })
            .addCase(fetchOrderDetails.rejected, (state, action) => {
                state.error = action.error.message;
            });
        builder
            .addCase(updateMyProfile.fulfilled, (state, action) => {
                state.updateState = true;
                if (action.payload.status == "SUCCESS") {
                    state.error = "";
                    //                        state.myOrders = action.payload.data;
                    //                        state.orderStatus = action.payload.OrderStatusData;
                } else {
                    state.error = action.payload.message;
                }
            })
            .addCase(updateMyProfile.rejected, (state, action) => {
                state.error = action.error.message;
            });
        builder
            .addCase(mobileVerify.fulfilled, (state, action) => {
                state.updateState = true;
                if (action.payload.status == "SUCCESS") {
                    state.error = "";
                    state.updateState = false;
                    //                        state.myOrders = action.payload.data;
                    //                        state.orderStatus = action.payload.OrderStatusData;
                } else {
                    state.error = action.payload.message;
                }
            })
            .addCase(mobileVerify.rejected, (state, action) => {
                state.error = action.error.message;
            });
        builder
            .addCase(changePassword.pending, (state) => {
                state.error = "";          // <-- clear error at request start!
                state.updateState = false; // (optional, good practice)
            })
            .addCase(changePassword.fulfilled, (state, action) => {
                if (action.payload.status === "SUCCESS") {
                    //                        console.log(state.myProfile.name);
                    state.updateState = true;
                    //                        state.orderStatus = action.payload.OrderStatusData;
                } else {
                    state.error = action.payload.message;
                }
            })
            .addCase(changePassword.rejected, (state, action) => {
                state.updateState = false;
                // Always set new error (even if same message), causes React effect to run again
                // Attach random string/timestamp if you want it always to be "different":
                if (typeof action.payload === "string") {
                    state.error = action.payload;
                } else if (typeof action.error?.message === "string") {
                    state.error = action.error.message;
                } else {
                    state.error = "Failed to update password";
                }
            });
        builder
            .addCase(fetchShippingAddress.fulfilled, (state, action) => {
                if (action.payload.status == "SUCCESS") {
                    //                        console.log(state.myProfile.name);
                    state.shippingAddress = action.payload.data?.result;
                    //                        state.orderStatus = action.payload.OrderStatusData;
                } else {
                    state.error = action.payload.message;
                }
            })
            .addCase(fetchShippingAddress.rejected, (state, action) => {
                state.error = action.error.message;
            });
        builder
            .addCase(deleteShippingAddress.fulfilled, (state, action) => {
                if (action.payload.status == "SUCCESS") {
                    state.success = true;
                    //                        state.shippingAddress = action.payload.data?.result;
                    //                        state.orderStatus = action.payload.OrderStatusData;
                } else {
                    state.error = action.payload.message;
                }
            })
            .addCase(deleteShippingAddress.rejected, (state, action) => {
                state.error = action.error.message;
            });
        builder
            .addCase(fetchNotifications.fulfilled, (state, action) => {
                if (action.payload.status === "SUCCESS") {
                    // console.log(action.payload.data.notifications,'action.payload.data');
                    state.notifications = action.payload.data;
                }
            })
            .addCase(fetchNotifications.rejected, (state, action) => {
                state.error = action.error.message;
            });
        builder
            .addCase(deleteNotification.fulfilled, (state, action) => {
                if (action.payload.status === "SUCCESS") {
                    state.notifications = action.payload.data;
                } else {
                    state.error = action.payload.message;
                }
            })
            .addCase(deleteNotification.rejected, (state, action) => {
                state.error = action.error.message;
            });
        builder
            .addCase(deleteAccount.fulfilled, (state, action) => {
                state.success = true;
            })
            .addCase(deleteAccount.rejected, (state, action) => {
                state.error = action.payload || action.error.message;
            });
    }
});

export default ProfileSlice.reducer;
export const { clearState } =
    ProfileSlice.actions;


